import { render, staticRenderFns } from "./categoriesPlaceholder.vue?vue&type=template&id=1e8b8104&scoped=true"
import script from "./categoriesPlaceholder.vue?vue&type=script&lang=js"
export * from "./categoriesPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./categoriesPlaceholder.vue?vue&type=style&index=0&id=1e8b8104&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8b8104",
  null
  
)

export default component.exports